import React from 'react';
import { Star, Quote } from 'lucide-react';
import { ELITE_REVIEWS } from '../mock';

const Reviews = () => {
  return (
    <section id="reviews" data-testid="reviews-section" className="relative bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mb-12">
          <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#2AA8E8]">Reviews</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0A1628] leading-[1.05]">
            Why Clients <span className="gold-text">Keep Coming Back</span>
          </h2>
          <div className="mt-5 flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#D4A24C] text-[#D4A24C]" />
              ))}
            </div>
            <span className="text-sm font-bold text-[#0A1628]">4.9/5 average</span>
            <span className="text-sm text-[#4A5A72]">· from verified brokers, dealers & retail customers</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ELITE_REVIEWS.map((r, i) => (
            <figure
              key={`${r.name}-${i}`}
              data-testid={`review-${i + 1}`}
              className="group relative bg-[#F7F9FC] border border-[#E5EAF2] rounded-2xl p-6 md:p-7 hover:border-[#0A1628] hover:bg-white hover:shadow-xl transition-all duration-300"
            >
              <Quote className="absolute top-5 right-5 w-7 h-7 text-[#D4A24C]/30 group-hover:text-[#D4A24C]/60 transition-colors" />
              <div className="flex mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#D4A24C] text-[#D4A24C]" />
                ))}
              </div>
              <blockquote className="text-[#0A1628] leading-relaxed text-sm md:text-base mb-5 font-medium">
                “{r.copy}”
              </blockquote>
              <figcaption className="flex items-center gap-3 pt-4 border-t border-[#E5EAF2]">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#0A1628] to-[#0E2744] flex items-center justify-center text-white font-extrabold text-sm">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-extrabold text-[#0A1628]">{r.name}</div>
                  <div className="text-xs text-[#4A5A72]">{r.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
